import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetCrecaAccountsService } from "@/features/accounts/creca/services/get-accounts-service";
import { SynchronizeAccountsService } from "@/features/accounts/creca/services/synchronize-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useGetCrecaAccountStates } from "@/features/accounts/creca/hooks/use-get-accounts-states";
import { useContext } from "react";


export const useGetCrecaAccount = () => {
  const {
    //crecaAccountId,
    crecaAccounts,
    //setCrecaAccountId,
    setCrecaAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = useGetCrecaAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const getCrecaAccountsService = new GetCrecaAccountsService();
  const synchronizeAccountsService = new SynchronizeAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // クレカ一覧取得
  const getCrecaAccounts = async (
    accountGroupId: string,
    crecaAccountId?: string,
    excludeUnselected?: boolean,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      let resCrecaAccounts = await getCrecaAccountsService.getCrecaAccounts({
        account_group_id: accountGroupId,
        ...(crecaAccountId !== undefined && { creca_account_id: crecaAccountId }),
        ...(excludeUnselected !== undefined && { exclude_unselected: excludeUnselected }), 
      });
      if (crecaAccountId !== undefined && resCrecaAccounts.length !== 0) {
        // クレカ同期
        const isSyncBank =  false; // 現在クレカはfalse固定にしてある
        await synchronizeAccountsService.synchronizeAccounts({
          account_group_id: accountGroupId,
          creca_account_id: crecaAccountId,
          is_sync_bank: isSyncBank,
        });

        // 再度、クレカ一覧取得
        resCrecaAccounts = await getCrecaAccountsService.getCrecaAccounts({
          account_group_id: accountGroupId,
          ...(crecaAccountId !== undefined && { creca_account_id: crecaAccountId }),
          ...(excludeUnselected !== undefined && { exclude_unselected: excludeUnselected }), 
        });
      }
      // 成功時の処理
      setCrecaAccounts(resCrecaAccounts);
      return resCrecaAccounts;
    } catch (error) {
      // エラーハンドリング
      console.log("getCrecaAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    //crecaAccountId,
    //setCrecaAccountId,
    crecaAccounts,
    setCrecaAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
    getCrecaAccounts: errorHandledAsync(getCrecaAccounts, setError),
  };
};
